<template>
  <div class="commerce-agent-order-edit-panel">
    <div @click="close">
      <i class="delete is-large is-pulled-right" />
      <p class="subtitle has-text-white">{{ $t("ecommerce.edit-order") }}</p>
    </div>
    <!-- <p class="is-flex">
      <span class="button has-text-link" @click="addItem"
        ><i class="fa fa-plus" />&nbsp;{{ $t("ecommerce.add-item") }}</span
      >&nbsp;
      <span class="button has-text-danger" @click="removeItem"
        ><i class="fa fa-minus" />&nbsp;{{ $t("ecommerce.remove-item") }}</span
      >
    </p> -->
    <p class="btn" @click="addItem">
      <span class="has-text-link"
        ><i class="fa fa-plus pad" />&nbsp;{{ $t("ecommerce.add-item") }}</span
      >
      <i class="fa fa-chevron-right is-pulled-right" />
    </p>
    <p class="btn" @click="removeItem">
      <span class="has-text-danger"
        ><i class="fa fa-minus pad" />&nbsp;{{
          $t("ecommerce.remove-item")
        }}</span
      >
      <i class="fa fa-chevron-right is-pulled-right" />
    </p>
    <p class="btn" @click="addDiscount">
      <span class="has-text-primary"
        ><i class="fa fa-percentage pad" />&nbsp;{{
          $t("ecommerce.add-discount")
        }}</span
      >
      <i class="fa fa-chevron-right is-pulled-right" />
    </p>
    <!-- <p v-if="isSuperUser()" class="btn" @click="editItem">
      <span><i class="fa fa-pencil-alt pad" />&nbsp;Edit Item</span>
      <i class="fa fa-chevron-right is-pulled-right" />
    </p> -->
    <p v-if="isSuperUser()" class="btn" @click="addNote">
      <span><i class="fa fa-pencil-alt pad" />&nbsp;Add Note</span>
      <i class="fa fa-chevron-right is-pulled-right" />
    </p>
  </div>
</template>

<script>
export default {
  name: "CommerceAgentOrderEditPanel",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    addItem() {
      this.$emit("add");
      this.close();
    },
    removeItem() {
      this.$emit("remove");
      this.close();
    },
    addDiscount() {
      this.$emit("discount");
      this.close();
    },
    addNote() {
      // this.$emit("note")
      this.infoToast("TODO");
      this.close();
    },
  },
};
</script>

<style scoped>
.commerce-agent-order-edit-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  padding-bottom: 30px;
  background-color: #1f1b24;
  /* color: white; */
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  /* box-shadow: 0 0 2px 2px black; */
}
.subtitle {
  margin-top: 8px;
  margin-bottom: 16px;
  margin-left: 6px;
  font-weight: 500;
}
.button {
  font-weight: 500;
  border-radius: 25px;
  width: 100%;
}
.btn {
  padding: 10px;
  background-color: white;
  width: 100%;
  margin-bottom: 6px;
  font-weight: 500;
  border-radius: 25px;
}
.fa-chevron-right {
  color: #333;
  padding: 4px;
}
.pad {
  margin: 0 8px;
}
</style>